"use client";
import React from "react";
import { Typography } from "antd";
import ContactInformation from "@/app/components/contactUsPage/contactInformation";
import LocationConnectionApp from "@contactUsPage/locationConnectionApp";
import ContactUsForm from "../components/contactUsPage/contactUsForm";
import dynamic from "next/dynamic";

const Map = dynamic(() => import("@/app/components/contactUsPage/map"), {
  ssr: false,
});

const ContactUs = () => {
  const { Title } = Typography;
  return (
    <div
      className="container flex flex-col pt-28 pb-16 md:pb-20 lg:pb-24 sm:pt-32 md:pt-36 mid:!pt-44 xl:!pt-48 gap-16 sm:gap-14 md:gap-16"
      id="contact-us"
    >
      <div className="flex flex-col w-full gap-8">
        <div className="flex flex-col items-center w-full">
          <Title level={1} className="H1 text-center">
            با ما در ارتباط باشید
          </Title>
          <p className="text-regal-black-lighter text-center w-full sm:w-2/3">
            برای شروع یک سرمایه‌گذاری پرسود در مسیر انرژی پاک، فقط یک قدم فاصله
            دارید، ما اینجا هستیم تا با تخصص و مشاوره، این مسیر را هموار کنیم.
            هر سوال یا ایده‌ای درباره آینده روشن خورشیدی دارید، فقط کافی است با
            ما در میان بگذارید.
          </p>
        </div>
        <div className="w-full flex flex-col md:flex-row gap-8 h-auto md:h-[25rem] md:max-h-[25rem]">
          <ContactUsForm />
          <ContactInformation />
        </div>
        <Map />
        <LocationConnectionApp />
      </div>
    </div>
  );
};

export default ContactUs;
